var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5233 14.4127H11.6847C12.3815 14.4127 12.9235 13.8571 12.9235 13.1429V2.26984C12.9235 1.55556 12.3815 1 11.6847 1H4.94865C4.25182 1 3.70984 1.55556 3.70984 2.26984V3.46032",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5233 14.4127H11.6847C12.3815 14.4127 12.9235 13.8571 12.9235 13.1429V2.26984C12.9235 1.55556 12.3815 1 11.6847 1H4.94865C4.25182 1 3.70984 1.55556 3.70984 2.26984V3.46032",
    stroke: "#3399FA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97487 16H2.23881C1.54198 16 1 15.4445 1 14.7302V4.4921C1 3.77781 1.54198 3.22226 2.23881 3.22226H8.97487C9.67171 3.22226 10.2137 3.77781 10.2137 4.4921V14.7302C10.2137 15.4445 9.67171 16 8.97487 16Z",
    fill: "white",
    stroke: "#3399FA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.2927e98d.svg";
export { ForwardRef as ReactComponent };